import { useState, useEffect } from "react";
import { PiNotebookLight } from "react-icons/pi";
import { FaRegTrashAlt } from "react-icons/fa";
import { Transition } from "@headlessui/react";
import {
  getClipboardTerms,
  deleteFromClipboard,
} from "../../../../api/universal";
import { panelClasses } from "../utils/constants";

const DropDownNotes = (props) => {
  const [clipboardTerms, setClipboardTerms] = useState([]);

  useEffect(() => {
    if (props.isDropDownNotesOpen) {
      getClipboardTerms().then((response) => {
        if (response.data) {
          const terms = response.data.map((term) => ({
            ts: term.date,
            term: term.term,
          }));
          setClipboardTerms(terms);
        }
      });
    }
  }, [props.isDropDownNotesOpen]);

  const copyToClipboard = async (text) => {
    await navigator.clipboard.writeText(text).catch(console.error);
  };

  const removeFromClipboard = (text) => {
    deleteFromClipboard(text);
    setClipboardTerms((prev) => prev.filter((i) => i.term !== text));
  };

  return (
    <div>
      <button
        onClick={() => {
          props.setIsDropDownNotesOpen(!props.isDropDownNotesOpen);
          props.setIsAgentSelectorOpen(false);
          props.setIsPromptLoaderOpen(false);
        }}
        className="inline-flex items-center gap-1.5 py-1 text-mutedText hover:text-mainText transition-colors font-light cursor-pointer"
      >
        <PiNotebookLight className="h-3.5 w-3.5" />
        <span className="text-[13px]">Notes</span>
      </button>

      <Transition
        show={props.isDropDownNotesOpen}
        enter="transition duration-150 ease-out"
        enterFrom="opacity-0 translate-y-2"
        enterTo="opacity-100 translate-y-0"
        leave="transition duration-100 ease-in"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 translate-y-1"
      >
        <div className="absolute left-0 right-0 bottom-full z-[70]">
          <div className={panelClasses}>
            <div className="max-h-[40vh] overflow-auto p-2">
              {clipboardTerms.length > 0 ? (
                <ul className="space-y-0.5">
                  {clipboardTerms.map((item, index) => (
                    <li
                      key={index}
                      className="group flex items-center justify-between rounded-lg px-3 py-2 hover:bg-btnHover transition-colors"
                    >
                      <button
                        className="w-full pr-2 text-left text-[13px] font-light text-mainText truncate cursor-pointer"
                        onClick={() => copyToClipboard(item.term)}
                        title={item.term}
                      >
                        {item.term}
                      </button>
                      <button
                        className="inline-flex items-center justify-center rounded-md p-1.5 text-mutedText/60 hover:text-logoutColor hover:bg-logoutColor/10 transition-colors cursor-pointer"
                        onClick={() => removeFromClipboard(item.term)}
                        aria-label="Delete"
                      >
                        <FaRegTrashAlt className="h-3 w-3" />
                      </button>
                    </li>
                  ))}
                </ul>
              ) : (
                <div className="px-3 py-6 text-[13px] font-light text-mutedText">
                  No saved notes yet.
                </div>
              )}
            </div>
          </div>
        </div>
      </Transition>
    </div>
  );
};

export default DropDownNotes;
